import {FC, useEffect, useState} from 'react'
import {OPEN_INSTALL_GUIDE_EVENT} from '../core/installPrompt'
import {InstallGuideDialog} from './InstallGuideDialog'
import '../installApp.scss'

/**
 * Mounted once in the panel layout: the install guide, opened by «نصب برنامه» wherever the panel
 * offers it (account menu, «امکانات تازه», the dashboard's notice) through openInstallGuide().
 */
export const InstallAppGate: FC = () => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const show = () => setOpen(true)
    window.addEventListener(OPEN_INSTALL_GUIDE_EVENT, show)
    return () => window.removeEventListener(OPEN_INSTALL_GUIDE_EVENT, show)
  }, [])

  return <InstallGuideDialog show={open} onClose={() => setOpen(false)} />
}
